module.exports = {"audiences":["dueSoonMembers"],"experimentAllocation":{"dueSoonMembers":1},"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/dueSoon.json
// module id = QLJZ
// module chunks = 0